import { PageRef } from 'providers/page-ref';

export type TrainingPageParams = {
  day?: string;
};

export const ITrainingPage: PageRef<TrainingPageParams, void> = {
  pageName: 'TrainingPage',
} as PageRef<TrainingPageParams, void>;
